module.exports = __webpack_public_path__ + "img/security-2.d27915c1.png";